export default __webpack_public_path__ + "static/media/back.431c27e2.svg";